import script from "./gsrbr0106.vue?vue&type=script&setup=true&lang=js"
export * from "./gsrbr0106.vue?vue&type=script&setup=true&lang=js"

import "./gsrbr0106.vue?vue&type=style&index=0&id=61efc3de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61efc3de"]])

export default __exports__